import { Card, Col, Row, Skeleton, Space } from "antd";

export function TableSkeleton({ rows = 6, columns = 5 }: { rows?: number; columns?: number }) {
  return (
    <Card>
      <Skeleton active paragraph={false} title={{ width: "30%" }} />
      <div style={{ marginTop: 16 }}>
        {Array.from({ length: rows }).map((_, rowIdx) => (
          <Space key={rowIdx} style={{ width: "100%", marginBottom: 12 }} size="middle">
            {Array.from({ length: columns }).map((__, colIdx) => (
              <Skeleton.Input key={colIdx} active size="small" style={{ width: 140 }} />
            ))}
          </Space>
        ))}
      </div>
    </Card>
  );
}

export function DetailSkeleton() {
  return (
    <Card>
      <Skeleton active title={{ width: "40%" }} paragraph={{ rows: 4 }} />
    </Card>
  );
}

/** Placeholder for a row of statistic cards (dashboards, capacity pages). */
export function StatsSkeleton({ count = 4 }: { count?: number }) {
  return (
    <Row gutter={16}>
      {Array.from({ length: count }).map((_, idx) => (
        <Col key={idx} flex={1}>
          <Card>
            <Skeleton active title={{ width: "60%" }} paragraph={{ rows: 1 }} />
          </Card>
        </Col>
      ))}
    </Row>
  );
}

/** Fallback for card/chart-heavy pages: a stats row over a content card. */
export function CardSkeleton() {
  return (
    <>
      <StatsSkeleton />
      <Card style={{ marginTop: 16 }}>
        <Skeleton active title={{ width: "30%" }} paragraph={{ rows: 5 }} />
      </Card>
    </>
  );
}
